import React, { createContext, useContext, useState } from 'react';
import { Chart as ChartJS } from 'chart.js';
export type ChartContextType = {
  chart: React.RefObject<ChartJS> | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setChartRef: (chart: any) => void;
} | null;

// Idk if this is a good solution of getting child ref from parent
// but i think that this is the best of solutions that i know
export const ChartContext = createContext<ChartContextType>(null);

export const ChartProvider: React.FC<Props> = React.memo(({ children }) => {
  const [chartRef, setChartRef] = useState<React.RefObject<ChartJS> | null>(
    null
  );

  const value = {
    chart: chartRef,
    setChartRef,
  };

  return (
    <ChartContext.Provider value={value}>{children}</ChartContext.Provider>
  );
});

type Props = { children: React.ReactNode };

export const useChartContext = () => {
  const context = useContext(ChartContext);
  if (!context) {
    throw new Error('useChartContext must be used within a ChartContext.');
  }
  return context;
};
